import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

// GRN stock (asset stock) list
export const grnStockListTodo = createAsyncThunk("grnStockList", async ({ pageable: data, navigate }) => {
  try {
    const res = await axios({
      method: "GET",
      url: process.env.REACT_APP_API_URL + `asset_stock_list`,
      params: {
        pageSize: data?.pageSize,
        pageNo: data?.currentPage,
        search: data?.search,
      },
      headers: { "Content-Type": "application/json", Authorization: SessionManager.getSession("user_token"), },
    });
    return res;
  } catch (error) {
    return error.response;
  }
}
);

const grnStockListSlice = createSlice({
  name: "grnStockList",
  initialState: {
    data: [],
  },
  extraReducers: (builder) => {
    builder.addCase(grnStockListTodo.fulfilled, (state, action) => {
      if (action?.payload?.status === 200) {
        // assuming API shape: { data: { data: [...] } } like other lists
        state.data = action.payload.data.data;
      } else if (action?.payload?.status === 401) {
        showTokenExpiredAlert(
          action?.payload?.data?.message,
          action.meta.arg.navigate
        );
      } else if (action?.payload?.status === 403) {
        showAccessDeniedAlert(action.meta.arg.navigate);
      } else {
        state.data = [];
      }
    });
    builder.addCase(grnStockListTodo.rejected, () => {
      // silent reject
    });
  },
});

export default grnStockListSlice.reducer;

